import { getDataWithName, decorateWithTimestampsForFirestore, removeUndefineds } from './FirestoreUtils'

function getMenuFromDoc (menuDoc) {
  let menu = getDataWithName(menuDoc)
  Object.keys(menu.menuItems).forEach(item => {
    if (menu.menuItems[item].sizes) {
      Object.keys(menu.menuItems[item].sizes).forEach(size => {
        menu.menuItems[item].sizes[size].size = size
      })
    }
  })
  return menu
}

export default class MenuService {
  constructor (orgRef) {
    this.menus = orgRef.collection('menus')
  }

  async getMenu (menuName) {
    let menuDoc = await this.menus.doc(menuName).get()
    let menu = getMenuFromDoc(menuDoc)
    return menu
  }

  async getMenus () {
    let menus = {}
    let menusSnapshot = await this.menus.get()
    if (menusSnapshot.size > 0) {
      menusSnapshot.docs.forEach(menuDoc => { menus[menuDoc.id] = getMenuFromDoc(menuDoc) })
    }
    return menus
  }

  addMenu (menu) {
    let menuName = menu.name
    delete menu.name
    decorateWithTimestampsForFirestore(menu)
    removeUndefineds(menu)
    Object.keys(menu.menuItems).forEach(item => removeUndefineds(menu.menuItems[item]))
    return this.menus.doc(menuName).set(menu)
  }

  deleteMenu (menuName) {
    return this.menus.doc(menuName).delete()
  }
}
